import React from "react";
import ReactDOMClient from "react-dom/client";
import { Base } from "./screens/Base";

const app = document.getElementById("app");
const root = ReactDOMClient.createRoot(app);
root.render(<Base />);
